module.exports = __webpack_public_path__ + "static/media/video-plus.f009eaed.svg";